import {firebase} from '../../base';

export const getCompanyById = async (id) => {
    try {
        const doc = await firebase.firestore()
            .collection('company')
            .doc(id)
            .get()
        if (!doc.exists) {
            return null
        }
        return {
            ...doc.data(),
            id: doc.id
        }
    }
    catch (error) {
        return null
    }
}

export const getClientsByCompany = async (id) => {
    try {
        const doc = await firebase.firestore()
            .collection('clients')
            .where('company', '==', id)
            .get()
        const data = doc.docs.map(doc => {
            return {
                ...doc.data(),
                id: doc.id
            }
        });
        return data;
    }
    catch (error) {
        return null
    }
}

export const getApplications = async () => {
    try {
        const doc = await firebase.firestore()
            .collection('submissoes')
            .get()
        const data = doc.docs.map(doc => {
            return {
                ...doc.data(),
                id: doc.id
            }
        });
        return data;
    }
    catch (error) {
        return null
    }
}

export const getApplicationById = async (id) => {
    try {
        const doc = await firebase.firestore()
            .collection('submissoes')
            .doc(id)
            .get();

        if (!doc.exists) {
            return null;
        }

        return {
            id: doc.id,
            ...doc.data()
        };
    } catch (error) {
        console.error('Error fetching application:', error);
        throw error;
    }
};

export const getApplicationsPending = async () => {
    try {
        const doc = await firebase.firestore()
            .collection('submissoes')
            .where('status', '==', 'pending')
            .get()
        const data = doc.docs.map(doc => {
            return {
                ...doc.data(),
                id: doc.id
            }
        });
        return data;
    }
    catch (error) {
        return null
    }
}
